// src/config.ts
// Store configuration variables here

// Mapbox access token
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiY29kZWdvZC1hZmsiLCJhIjoiY203NzhibmVuMTNzNTJpcHh5c2JqeXM2MyJ9.d8wgY8C6P3KVG3cTzq2FFQ';//process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1IjoiY29kZWdvZC1hZmsiLCJhIjoiY203NzhibmVuMTNzNTJpcHh5c2JqeXM2MyJ9.d8wgY8C6P3KVG3cTzq2FFQ';
// Map default settings
export const MAP_DEFAULT_CENTER: [number, number] = [73.8567, 18.5204]; // Default to Pune, India
export const MAP_DEFAULT_ZOOM = 11;

// Color configurations
export const COLORS = {
  // Trip colors - use a consistent palette for trip polygons
  tripColors: [
    '#4285F4', // Blue
    '#EA4335', // Red
    '#FBBC05', // Yellow
    '#34A853', // Green
    '#8E24AA', // Purple
    '#F4511E', // Deep Orange
    '#6D4C41', // Brown
    '#039BE5', // Light Blue
    '#7CB342', // Light Green
    '#C0CA33', // Lime
  ],
  
  // Touch point accuracy colors
  touchPointAccuracy: {
    HIGH: '#34A853', // Green
    MEDIUM: '#FBBC05', // Yellow
    LOW: '#EA4335', // Red
  },
  
  // Editing mode colors
  editing: {
    selectedTrip: '#2979FF',
    selectedTouchPoint: '#FF6D00',
    destinationTrip: '#00C853',
  },
};

// Metric tooltips
export const METRICS_INFO = {
  noOfTrips: {
    title: 'Number of Trips',
    description: 'Total number of vehicle trips in the current plan'
  },
  tpPerTrip: {
    title: 'Points per Trip',
    description: 'Average number of touch points assigned to each trip'
  },
  wtPerTripKg: {
    title: 'Weight per Trip',
    description: 'Average delivered weight handled per trip'
  },
  distPerTripKm: {
    title: 'Distance per Trip',
    description: 'Average kilometers covered by each trip'
  },
  ctoGmv: {
    title: 'C% GMV',
    description: 'Cost as percentage of Gross Merchandise Value'
  },
  cpk: {
    title: 'Cost per Kilometer (CPK)',
    description: 'Average cost of operation per kilometer traveled'
  },
  cpTp: {
    title: 'Cost per Touch Point (CPT)',
    description: 'Average cost per touch point delivery'
  },
  wtBreachKg: {
    title: 'Overweight',
    description: 'Number of trips exceeding weight capacity limits'
  },
  volBreachCuFt: {
    title: 'Overflow',
    description: 'Number of trips exceeding volume capacity limits'
  },
  slotBreaches: {
    title: 'Slot Breach',
    description: 'Number of deliveries outside their assigned time slots'
  },
  slotSlippages: {
    title: 'Slot Breaches',
    description: 'Count of trips that missed their assigned delivery windows'
  },
  tpsWithoutTrip: {
    title: 'Unallocated Touch Points',
    description: 'Number of touch points not assigned to any trip'
  },
  timeBreach: {
    title: 'Time Breaches',
    description: 'Trips exceeding allowable travel time or time windows'
  },
  editPercent: {
    title: 'Edit %',
    description: 'Percentage of the plan that has been modified from the original'
  },
};
